import React, { useState, useEffect } from 'react';
import { Row, Column } from '@dls/web';
import { IHeader } from './models/HeaderModel';
import { StyledHeader, StyledHeaderRow, HeaderRight, StyledLogo } from './styles';
import { v4 as uuid } from 'uuid';

const logo = require('@/assets/images/singtel-logo-white.png');

const Header = ({ isAuth, isMobileView, rightItems, onMenuClick, checkPdpa }: IHeader) => {
  const [drawer, triggerDrawer] = useState(false);
  useEffect(() => {
    if (!isMobileView && drawer) {
      triggerDrawer(false);
    }
  }, [isMobileView, drawer]);

  return (
    <StyledHeader data-testid="header">
      <StyledHeaderRow fluid middle="xs">
        <Column xs={1}>{isAuth && isMobileView && <Row center="xs"></Row>}</Column>
        {checkPdpa ? (
          <a data-testid="home">
            <StyledLogo src={logo.default} alt="logo" />
          </a>
        ) : (
          <Column xs={5}>
            <Row middle="xs">
              <a data-testid="home" onClick={onMenuClick({ pathname: 'HOME' })}>
                <StyledLogo src={logo.default} alt="logo" />
              </a>
            </Row>
          </Column>
        )}
        {checkPdpa ? null : (
          <Column xs={6}>
            {isAuth && (
              <HeaderRight data-testid="header-right" style={{ justifyContent: 'end' }}>
                {rightItems.map((item) => (
                  <Column noGutter key={uuid()}>
                    {item}
                  </Column>
                ))}
              </HeaderRight>
            )}
          </Column>
        )}
      </StyledHeaderRow>
    </StyledHeader>
  );
};

export default Header;
